import React from 'react';
import { useRecoilValue } from 'recoil';
import { FeatureFlagProvider } from '@pm/shared';
import { pharmacyIdState } from '../atoms/id';

interface FlagsWrapperProps {
	children: React.ReactNode;
}

export const FlagsWrapper: React.FC<FlagsWrapperProps> = ({ children }) => {
	const pharmacyId = useRecoilValue(pharmacyIdState);

	return (
		<FeatureFlagProvider
			pharmacyId={pharmacyId}
			apiUrl={import.meta.env.VITE_MARKETPLACE_API_URL || ''}
			tokenKey={import.meta.env.VITE_AUTH_TOKEN_KEY || 'authToken'}
		>
			{children}
		</FeatureFlagProvider>
	);
};
